<template>
  <div class="brand-detection__card-info">
    <div class="brand-detection__card-title acr-bold-22">{{ video.display_name }}</div>
    <div class="brand-detection__card-columns">
      <div
        v-for="item in items"
        class="brand-detection__card-column"
        :key="item.label">
        <span class="label">{{ item.label }}:</span>
        <span class="value">{{ item.value || '&#8212;' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { formatSeconds } from "@/utils/utils";

export default {
  name: "VideoInfo",
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
  computed: {
    items() {
      return [
        {
          label: 'Type',
          value: this.video.event_name,
        },
        {
          label: 'Place',
          value: this.video.event_place,
        },
        {
          label: 'Date',
          value: this.formatEventDate(this.video.event_date),
        },
        {
          label: 'Duration',
          value: formatSeconds(this.video.video_duration_sec),
        },
        {
          label: 'Resolution',
          value: `${this.video.video_width} x ${this.video.video_height}`,
        },
        {
          label: 'FPS',
          value: this.video.video_fps.toFixed(2),
        },
        {
          label: 'Broadcast',
          value: this.video.priceSettings.broadcast,
        },
        {
          label: 'Ad price per second',
          value: this.getValuePerSecond(this.video),
        },
      ]
    },
  },
  methods: {
    getValuePerSecond({ priceSettings }) {
      const { length, price, symbol } = priceSettings;
      if (!price || !length) {
        return '-';
      }
      return `${symbol} ${(price / length).toFixed(2)}`;
    },
    formatEventDate(date) {
      if (!date) {
        return null;
      }
      return moment(date).format('YYYY-MM-DD');
    },
  }
}
</script>
